import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiRequest } from "../../api/baseApi";
import Layout from "../../components/layout/Layout";
import { useSyncSelectedClient } from "../../Hooks/useSyncSelected";
import { AuthContext } from "../../state/AuthContext";
import { ClientContext } from "../../state/ClientContext";
import "./AssignmentCenterPage.css";
import { toast } from "react-toastify";

const AssignmentCenterHeader = ({ children }) => {
  useSyncSelectedClient();
  const navigate = useNavigate();

  return (
    <div>
      <table>
        <tbody>
          <tr>
            <td>
              <h1 style={{ textAlign: "left", fontSize: "2.6rem" }}>
                <strong>Assignment Center</strong>
              </h1>
              <h5>Manage which clients are assigned to which caregivers.</h5>
            </td>
            <td style={{ textAlign: "right", verticalAlign: "bottom" }}>
              <button
                className="btn-primary"
                onClick={() => navigate("/add_new_assignment")}
              >
                Add new assignment
              </button>
            </td>
            {children}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const AssignmentCenterPage = () => {
  const navigate = useNavigate();
  const { currentUser } = useContext(AuthContext);
  const [isLoaded, setIsLoaded] = useState(false);
  const { clients, refetchClients } = useContext(ClientContext);

  useEffect(() => {
    setIsLoaded(true);
  }, [isLoaded]);

  async function handleUnassignCaregiverClick(ev, client, caregiverId) {
    ev.preventDefault();

    if (!window.confirm("Are you sure you wanna unassign this caregiver?")) {
      return;
    }

    const response = await apiRequest(
      `/clients/${client.id}/unassignCaregiver`,
      {
        method: "POST",
        body: { caregiverId },
        version: "v1",
      },
    );
    await response.json();

    if (response.ok) {
      toast.success("Unassigned");
      refetchClients();
    }
  }

  return !isLoaded ? null : (
    <Layout showSideNav={false}>
      <div className="container-assignment-center">
        <AssignmentCenterHeader />
        <div className="container-clients-caregivers">
          <table className="tbl-clients-caregivers">
            <tbody>
              <tr className="tbl-header">
                <th>Clients</th>
                <th colSpan={2}>Caregivers</th>
              </tr>
              {(clients ?? []).map((client) => (
                <tr className="tbl-rows" key={client.id}>
                  <td className="client-info">
                    <p>
                      <strong>{client.name}</strong>
                    </p>
                    <a
                      href=""
                      onClick={(ev) => {
                        ev.preventDefault();
                        navigate(`/client_profile/${client.id}`, {
                          state: { user: client },
                        });
                      }}
                    >
                      Go to Client
                    </a>
                  </td>
                  <td
                    style={
                      (client.caregivers ?? []).length > 0
                        ? { width: "250px" }
                        : { textAlign: "center" }
                    }
                    colSpan={(client.caregivers ?? []).length > 0 ? 1 : 2}
                  >
                    {(client.caregivers ?? []).length > 0 ? (
                      <span>is assigned to</span>
                    ) : (
                      <span>isn’t assigned to any caregivers yet.</span>
                    )}
                  </td>
                  {(client.caregivers ?? []).length < 1 ? null : (
                    <td>
                      {(client.caregivers ?? []).map((caregiver) => (
                        <div style={{ display: "flex" }} key={caregiver.id}>
                          <strong style={{ minWidth: "400px" }}>
                            {caregiver.id !== currentUser.id
                              ? caregiver.name
                              : "Me"}
                          </strong>
                          {caregiver.id === currentUser.id ? null : (
                            <div>
                              <a
                                href=""
                                onClick={(ev) => {
                                  ev.preventDefault();

                                  navigate(
                                    `/caregiver_profile/${caregiver.id}`,
                                  );
                                }}
                              >
                                Go to caregiver
                              </a>
                              &nbsp; | &nbsp;
                              <a
                                href=""
                                onClick={(ev) =>
                                  handleUnassignCaregiverClick(
                                    ev,
                                    client,
                                    caregiver.id,
                                  )
                                }
                              >
                                Unassign caregiver
                              </a>
                            </div>
                          )}
                        </div>
                      ))}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
};

export default AssignmentCenterPage;
